import { ReactNode } from 'react';
import { MasonryGridContainer, MasonryGridItemBox } from './styles';

interface MasonryGridProps<ItemType extends { id: string }> {
    items: ItemType[];
    renderItem: (item: ItemType, index: number) => ReactNode;
}

/** Масонри на CSS-колонках: без замеров и эффектов, поэтому целиком приходит из SSR */
export const MasonryGrid = <ItemType extends { id: string }>({
    items,
    renderItem,
}: MasonryGridProps<ItemType>) => (
    <MasonryGridContainer>
        {items.map((item, index) => (
            <MasonryGridItemBox key={item.id}>{renderItem(item, index)}</MasonryGridItemBox>
        ))}
    </MasonryGridContainer>
);
